import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTransition, animated } from 'react-spring/web.cjs';

import Dropdown from './Dropdown';
import WeightroomSearch from '../container/WeightroomSearch';
import AthletePicker from './AthletePicker';
import WeightroomPinPad from '../container/WeightroomPinPad';

const PanelChooseHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px 15px 30px;

  @media screen and (orientation: portrait) {
    padding: 25px 20px 15px 20px!important;
  }
`;

const AthletePickerWrapper = styled('div')`
  /* ${props => (
    props.activeScreens === 4
      ? 'height: calc(50vh - 108px);'
      : 'height: calc(100vh - 108px);'
  )} */
  flex: 1;

  @media screen and (orientation: portrait) {
    ${props => (
    props.activeScreens === 2 && `
      height: calc(50vh - 108px);
    `
  )}
  }

  @media screen and (orientation: landscape) {
    ${props => (
    props.activeScreens === 2 && `
      height: calc(100vh - 108px);
    `
  )}
  }
`;

const panelStyle = {
  display: 'inherit',
  flexDirection: 'inherit',
  position: 'inherit',
  width: 'inherit',
  height: 'inherit',
};

const PanelAthletes = (props) => {
  const {
    activeScreens,
    data,
    groupFilter,
    isPinPadOpen,
    isDimensionSet,
    namespace,
    openPinPad,
    panelDimensions,
    selectAthlete,
    userGroups,
  } = props;

  const isSilkBrowser = /\bSilk\b/.test(navigator.userAgent);

  const handleActiveAthlete = (name) => {
    if (name.pinEnabled === 'true') {
      openPinPad(name.name, name.id, name.avatar, namespace);
    }
    if (name.pinEnabled === 'false') {
      selectAthlete(name.name, name.id, name.avatar, namespace);
    }
  };

  const transitions = useTransition(isPinPadOpen, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const nonAnimatedPinPad = isPinPadOpen ? (
    <div
      style={{
        display: 'inherit',
        flexDirection: 'inherit',
        position: 'inherit',
        width: 'inherit',
        height: 'inherit',
      }}
    >
      <WeightroomPinPad
        namespace={namespace}
      />
    </div>
  ) : (
    <div
      style={{
        display: 'inherit',
        flexDirection: 'inherit',
        position: 'inherit',
        width: 'inherit',
        height: 'inherit',
      }}
    >
      <PanelChooseHeader>
        <Dropdown
          data={userGroups.result}
        />
        <WeightroomSearch namespace={namespace} />
      </PanelChooseHeader>
      <AthletePickerWrapper
        activeScreens={activeScreens}
      >
        <AthletePicker
          handleActive={handleActiveAthlete}
          groupFilter={groupFilter}
          data={data}
          isDimensionSet={isDimensionSet}
          namespace={namespace}
          panelDimensions={panelDimensions}
        />
      </AthletePickerWrapper>
    </div>
  );

  const animatedPinPad = transitions.map(({ item, key, props }) => (
    item ? (
      <animated.div
        key={key}
        style={{
          ...props,
          display: 'inherit',
          flexDirection: 'inherit',
          position: 'inherit',
          width: 'inherit',
          height: 'inherit',
        }}
      >
        <WeightroomPinPad
          namespace={namespace}
        />
      </animated.div>
    ) : (
      <animated.div
        key={key}
        style={{
          ...props,
          display: 'inherit',
          flexDirection: 'inherit',
          position: 'inherit',
          width: 'inherit',
          height: 'inherit',
        }}
      >
        <PanelChooseHeader>
          <Dropdown
            data={userGroups.result}
          />
          <WeightroomSearch namespace={namespace} />
        </PanelChooseHeader>
        <AthletePickerWrapper
          activeScreens={activeScreens}
        >
          <AthletePicker
            handleActive={handleActiveAthlete}
            groupFilter={groupFilter}
            isDimensionSet={isDimensionSet}
            data={data}
            namespace={namespace}
            panelDimensions={panelDimensions}
          />
        </AthletePickerWrapper>
      </animated.div>
    )
  ));

  return (
    <Fragment>
      {isSilkBrowser ? (
        nonAnimatedPinPad
      ) : (
        animatedPinPad
      )}
    </Fragment>
  );
};

PanelAthletes.propTypes = {
  activeScreens: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Array).isRequired,
  groupFilter: PropTypes.string.isRequired,
  isPinPadOpen: PropTypes.bool.isRequired,
  namespace: PropTypes.string.isRequired,
  openPinPad: PropTypes.func.isRequired,
  // panelHeight: PropTypes.number.isRequired,
  selectAthlete: PropTypes.instanceOf(Function).isRequired,
  userGroups: PropTypes.instanceOf(Object).isRequired,
};

export default PanelAthletes;
